export default function (app) {
	app.directive('noValidation', function () {
		return {
			require: 'ngModel',
			link: function noValidation(scope, elem, attrs, ngModelController) {

				function wrapOriginalValidators() {
					var originalValidators = angular.copy(ngModelController.$validators);
					Object.keys(originalValidators).forEach(function (key) {
						ngModelController.$validators[key] = function (modelValue, viewValue) {
							return scope.$eval(attrs.noValidation) || originalValidators[key](modelValue, viewValue);
						};
					});
				}

				function watchDisableCriteria() {
					scope.$watch(attrs.noValidation, function () {
						// trigger validation
						var originalViewValue = ngModelController.$viewValue;
						scope.$applyAsync(function () {
							ngModelController.$setViewValue('');
						});
						scope.$applyAsync(function () {
							ngModelController.$setViewValue(originalViewValue);
						});
					});
				}

				wrapOriginalValidators();
				watchDisableCriteria();

			}
		};
	});
};
